<template>
  <div>
    <v-dialog v-model="dialogregionwise" fullscreen persistent>
      <v-toolbar fixed color="white">
        <v-toolbar-title class="mb-2">
          <h3 class="titleText--text">
          {{ parmVariablename }}</h3></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="mb-2">
          <v-btn icon dark @click="dialogregionwise = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card flat color="rgb(243, 245, 248)">
        <v-card-title >
            <div style="width: 600px">
                <h5 class="grey--text ml-1">Select region</h5>
                <v-select
                v-model="dataregionSelected"
                :items="dataregion"
                flat
                solo
                multiple
                hide-details="auto"
                class="mb-5 mt-1 custom-shadow"
                style="border-radius: 8px"
                small-chips
                @change="callRegionChangeEvent()"
                >
                <template v-slot:selection="{ item }">
                <v-chip small color="blue" text-color="white" class="my-1">
                  <div>
                    <span class="font-weight-bold float-left">{{ item }}</span>
                  </div>
                </v-chip>
              </template>
      </v-select>
      </div>
          </v-card-title>
        <v-card-text class="mt-0">
          <div class="mt-0">
            
            <v-row
              ><v-col
                cols="6"
                v-for="item in dataregionSelected"
                :key="item.region"
              >
                <v-card flat class="custom-shadow">
                  <v-card-title>
                    <h3 class="titleText--text">{{ item }}</h3>
                  </v-card-title>
                  <v-card-text class="pa-6">
                    <CtrlRegionWiseView
                      ref="ctrlRegionWiseView"
                      :statisticsdata="getmodel_statisticsdata(item)"
                      :coefficientsdata="getmodel_coefficientsdata(item)"
                      :actualpredictedchartdata="
                        getmodel_actualpredictedchartdata(item)
                      "
                      :volume_area_chart="getfilterdate_volume_area_chart(item)"
                      :title="item"
                    ></CtrlRegionWiseView>
                  </v-card-text>
                </v-card>
                </v-col>
                </v-row>
                </div>
              </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apifactory from "../api";
import CtrlRegionWiseView from "./RegionwiseView/CtrlRegionWiseView.vue";
export default {
  data: () => ({
    itemlistfinal: [],
    itemlistcoefficients_table: [],
    itemlistmodel_statistics: [],
    itemlistactual_predicted_chart: [],
    itemlistvolume_area_chart: [],
    dialogregionwise: false,
    parmVariablename: "Region: Coefficients & Statistics",
    dataregion: [],
    dataregionSelected: [],
  }),
  components: {
    CtrlRegionWiseView,
  },
  methods: {
    getmodel_statisticsdata(varregion) {
      return this.getfilterdate_model_statistics().filter(
        (a) => a.region == varregion
      );
    },
    getmodel_coefficientsdata(varregion) {
      return this.getfilterdate_coefficients_table().filter(
        (a) => a.region == varregion
      );
    },
    getmodel_actualpredictedchartdata(varregion) {
      return this.getfilterdate_actual_predicted_chart().filter(
        (a) => a.region == varregion
      );
    },
    callRegionChangeEvent() {
      this.itemlistcoefficients_table = this.getfilterdate_coefficients_table();
      this.itemlistmodel_statistics = this.getfilterdate_model_statistics();
      this.itemlistactual_predicted_chart =
        this.getfilterdate_actual_predicted_chart();
      this.itemlistvolume_area_chart = this.getfilterdate_volume_area_chart();
    },
    OnloadCall(vardata, varregionlist) {
      //alert("call OnloadCall" + JSON.stringify(vardata));
      this.dialogregionwise = true;
      this.itemlistfinal = vardata;
      this.dataregion = varregionlist;
    },

    get_saved_vargrp_for_model() {
      apifactory
        .api_get_vargrp_for_model()
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            let templist = [];
            templist = res.data.variable_group;
            alert(JSON.stringify(templist));
            let finallist = [];
            let index = 1;
            for (let element in templist) {
              let obj = new Object();
              obj.id = index;
              obj.variable = element;
              obj.base = false;
              obj.increment = false;
              obj.other = false;
              if (templist[element] == "0") {
                obj.base = true;
              }
              if (templist[element] == "1") {
                obj.increment = true;
              }
              if (templist[element] == "2") {
                obj.other = true;
              }
              obj.value = templist[element];
              index = index + 1;
              finallist.push(obj);
              //alert(element);
            }
            this.itemlistfinal = finallist;
            //alert(JSON.stringify(finallist));
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    getfilterdate_coefficients_table() {
      //let filterlist=[];
      let data = [];

      for (let el in this.itemlistfinal.coefficients_table) {
        //alert(this.itemlistfinal.coefficients_table[el].region);
        for (let k in this.dataregionSelected) {
          if (
            this.itemlistfinal.coefficients_table[el].region ==
            this.dataregionSelected[k]
          ) {
            data.push(this.itemlistfinal.coefficients_table[el]);
          }
        }
      }

      return data;
    },
    getfilterdate_model_statistics() {
      //let filterlist=[];
      let data = [];

      for (let el in this.itemlistfinal.model_statistics) {
        //alert(this.itemlistfinal.coefficients_table[el].region);
        for (let k in this.dataregionSelected) {
          if (
            this.itemlistfinal.model_statistics[el].region ==
            this.dataregionSelected[k]
          ) {
            data.push(this.itemlistfinal.model_statistics[el]);
          }
        }
      }

      return data;
    },
    getfilterdate_actual_predicted_chart() {
      //let filterlist=[];
      let data = [];

      for (let el in this.itemlistfinal.actual_predicted_chart) {
        //alert(this.itemlistfinal.coefficients_table[el].region);
        for (let k in this.dataregionSelected) {
          if (
            this.itemlistfinal.actual_predicted_chart[el].region ==
            this.dataregionSelected[k]
          ) {
            data.push(this.itemlistfinal.actual_predicted_chart[el]);
          }
        }
      }

      return data;
    },
    getfilterdate_volume_area_chart() {
      //let filterlist=[];
      let data = [];

      for (let el in this.itemlistfinal.volume_area_chart) {
        //alert(this.itemlistfinal.coefficients_table[el].region);
        for (let k in this.dataregionSelected) {
          if (
            this.itemlistfinal.volume_area_chart[el].region ==
            this.dataregionSelected[k]
          ) {
            data.push(this.itemlistfinal.volume_area_chart[el]);
          }
        }
      }

      return data;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 25px;
  color: black;
}

.headerboxtitle {
  font-size: 20px;
}

.card2 {
  background-color: #ffff00;
}
.customselectbox {
  padding-top: 10px !important;
  width: 60% !important;
  right: 0%;
}
.custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important;
}
</style>
